/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_See_BreakdownInputs */



/**
* | output |
* | --- |
* | "See breakdown" |
*
* @param {Dashboard_Billing_See_BreakdownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_see_breakdown = /** @type {((inputs?: Dashboard_Billing_See_BreakdownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_See_BreakdownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufschlüsselung ansehen")
	return /** @type {LocalizedString} */ ("See breakdown")
});